import { AppDefProcess, AppDefScreen } from "./config"

export let baseScreens = {
  SYSEPT: <AppDefScreen>{},
  SYSLandingPage01: <AppDefScreen>{},
  SYSAudit: <AppDefScreen>{},
  SYSTranslation: <AppDefScreen>{},
  SYSTableDetailView: <AppDefScreen>{},
}

export let baseEditors = {
  SYSEditorAsset: {},
  SYSEditorForm: {},
}

export let baseDialogs = {
  SYSTableSettings_ColumnFilter: {},
  SYSTableSettings_FilterSort: {},
  SYSLogin: {},
  SYSTOTP: {},
  SYSPortalSettings: {},
  SYSUserAdministration_User: {},
  SYSUserAdministration_Company: {},
  SYSUserAdministration_Role: {},
  SYSUserAdministration_UserRole: {},
  SYSUserAdministration_Permission: {},
  SYSUserAdministration_UserRoleTransfer: {},
  SYSTableSettings_AdvancedFilter: {},
  SYSModal: {},
  SYSTableHeaderMenu: {},

  SYSHitListDialog: { rehydratable: false },
  SYSTableRowDetailView: {},
  SYSTableRowEdit: {},
  SYSEditorAsset: { rehydratable: false },
}

export let baseForms = {
  SYSTableRowEdit: {},
  SYSEditorAsset: {},
  SYSHeaderMenuFilter: {},
  SYSLogin: {},
  SYSTOTP: {},
  SYSPortalSettings: {},
  SYSUserSettingsPassword: {},
  SYSPasswordVisibility: {},

  // multi purpose edit form
  SYSEdit: {},
}

export let baseLongRunningProcess = {
  SYSUserAdministrationUserRoleDoTransfer: <AppDefProcess>{
    snack: { type: "BusyIndicator" },
  },

  SYSUserSettingsSave: <AppDefProcess>{ snack: { type: "BusyIndicator" } },
  SYSEPTCheck: <AppDefProcess>{
    snack: { type: "BusyIndicator" },
    lockScreen: true,
  },

  SYSLoginLogin: <AppDefProcess>{ snack: { type: "BusyIndicator" } },
  SYSTOTP: <AppDefProcess>{},
  SYSUserSettingsSaveSettings: <AppDefProcess>{},

  SYSTableRefresh: <AppDefProcess>{ isRefresh: true },
  SYSTableRebuild: {},
  SYSSaveRow: { lockScreen: true },

  SYSSave: <AppDefProcess>{
    snack: {
      type: "BusyIndicator",
      alternativeTranslationKey: "SYSTableRowFnSave",
    },
    lockScreen: true,
  },

  SYSFileUpload: {},
  SYSGetLookupData: {},
  SYSTableRowFnProcess: <AppDefProcess>{
    snack: { type: "BusyIndicator" },
  },
  SYSFileGet: { snack: { type: "BusyIndicator" } },
}
